{
  "button": {
    "back": "חזור",
    "buy_now": "קנה עכשיו",
    "cancel": "ביטול",
    "clear_all": "נקה הכל",
    "confirm": "אישור",
    "delete": "מחיקה",
    "download": "הורד",
    "edit": "לַעֲרוֹך",
    "enter_another_card": "הזן כרטיס אחר",
    "enter_another_code": "הזן קוד אחר",
    "exit": "יְצִיאָה",
    "full": "מלא",
    "get": "להורדה",
    "go_to_homepage": "עבור לעמוד הבית",
    "no": "לא",
    "regular": "רגיל",
    "remove": "לְהַסִיר",
    "rename": "שנה שם",
    "slide_back": "שקופית קודמת",
    "slide_forward": "השקף הבא",
    "submit_code": "שלח קוד",
    "toggle_dark": "מצב כהה",
    "toggle_langs": "שנה שפות",
    "try_again": "נסה שוב"
  },
  "errors": {
    "could_not_find_event": "מצטערים, לא הצלחנו למצוא את האירוע שאתה מחפש.",
    "could_not_find_league": "מצטערים, לא הצלחנו למצוא את הליגה שאתה מחפש.",
    "could_not_find_page": "מצטערים, לא הצלחנו למצוא את הדף שאתה מחפש.",
    "could_not_find_results": "מצטערים, לא מצאנו תוצאות לחיפוש זה.",
    "could_not_find_team": "מצטערים, לא הצלחנו למצוא את הצוות שאתה מחפש.",
    "default_error_message": "אירעה שגיאת שרת. \nבבקשה נסה שוב מאוחר יותר",
    "device_limit_exceeded": "חרגת ממגבלת המכשירים!",
    "ERR400CL11": "יצירת הקליפ נכשלה",
    "ERR400CM11": "התשלום נכשל",
    "ERR400CM12": "ההזמנה נכשלה",
    "ERR400CM13": "לכידת תשלום נכשל",
    "ERR400CM14": "פרטי סוחר שמירת המינוי נכשלו",
    "ERR400CM15": "אנא בדוק את פרטי כרטיס האשראי שלך",
    "ERR400CM16": "סופק ערך פלטפורמה לא חוקי",
    "ERR400GN00": "בקשה גרועה",
    "ERR400GN11": "קוד זהה לא חוקי סופק",
    "ERR400GN12": "שדות לא ניתנים לעדכון",
    "ERR400ID11": "סופקה זהות לא חוקית",
    "ERR400ID12": "פריט זהות לא חוקי סופק",
    "ERR400ID13": "לא ניתן להוסיף זהות לרשימת המועדונים",
    "ERR400ID14": "זוג זהות ופריט זהות לא חוקיים סופק",
    "ERR400TG11": "יצירת התג נכשלה",
    "ERR400UR11": "נדרשים שם פרטי ושם משפחה של הפרופיל",
    "ERR400UR12": "נדרש אימייל",
    "ERR400UR13": "למשתמש כבר יש כרטיס אשראי שמור",
    "ERR400UR14": "אנא מלא את השם הפרטי, שם המשפחה ושדות הדוא\"ל של הפרופיל שלך לפני שתשמור כרטיס אשראי",
    "ERR400UR17": "למשתמש אין כרטיס אשראי לעריכה",
    "ERR400UR18": "המנוי כבר בוטל",
    "ERR400UR19": "המנוי אינו פעיל",
    "ERR400UR20": "נדרשים שם משתמש וסיסמה",
    "ERR400UR21": "החשבון אינו פעיל",
    "ERR400UR24": "הסיסמה הישנה שגויה. \nאנא בדוק את האישור שלך",
    "ERR401AT11": "נדרש אסימון",
    "ERR401AT12": "אסימון איפוס סיסמה לא חוקי",
    "ERR401AT13": "אסימון רענון לא חוקי",
    "ERR401AT14": "מנפיק נושא לא ידוע",
    "ERR401AT15": "סוג אסימון נושא לא נתמך",
    "ERR401AT16": "אסימון לא חוקי",
    "ERR401AT17": "אסימון שפג תוקפו",
    "ERR401AT18": "השגת אימייל מהאסימון נכשלה",
    "ERR401AT19": "המשתמש לא נמצא",
    "ERR401GN00": "לא מורשה",
    "ERR401UR11": "שם המשתמש או הסיסמה שגויים. \nאנא בדוק את האישורים שלך.",
    "ERR402GN00": "נדרש תשלום",
    "ERR403GN00": "אסור",
    "ERR403TG11": "המשתמש לא יכול לעדכן תגים גלובליים",
    "ERR403TG12": "המשתמש לא יכול ליצור תגים גלובליים",
    "ERR403TG13": "המשתמש אינו יכול למחוק את התגים שלא נוצרו על ידי אחד",
    "ERR403TG14": "המשתמש אינו יכול למחוק תגים גלובליים",
    "ERR404CM11": "לא ניתן לקבל מנויים",
    "ERR404CM12": "קוד גישה לא נמצא",
    "ERR404EV11": "לא ניתן לקבל מידע על האירוע",
    "ERR404EV12": "האירוע או ה-VOD לא נמצאו",
    "ERR404GN00": "לא נמצא",
    "ERR404ID00": "זהות לא נמצאה",
    "ERR404ID11": "לא ניתן היה לאחזר את הזהות",
    "ERR404PR00": "מוצר לא נמצא",
    "ERR404PR11": "לא יכול לקבל מידע ppv",
    "ERR404TG00": "התג לא נמצא",
    "ERR404TM00": "הצוות לא נמצא",
    "ERR404UR00": "המשתמש לא נמצא",
    "ERR404UR11": "ההזמנה לא נמצאה",
    "ERR404UR12": "מנוי לא נמצא",
    "ERR404UR13": "משתמש לא קיים",
    "ERR404UR14": "הפרופיל לא קיים",
    "ERR404UR15": "כרטיס לא נמצא עבור משתמש זה",
    "ERR404UR16": "הסרטון לא נמצא ברשימת הצפייה",
    "ERR404VD11": "לא ניתן היה לאחזר Vod",
    "ERR409CM11": "קוד גישה כבר בשימוש",
    "ERR409GN00": "סְתִירָה",
    "ERR409PR12": "המוצר כבר נרכש",
    "ERR409UR11": "המועדון כבר נוסף",
    "ERR409UR12": "משתמש כבר רשום",
    "ERR422GN00": "תוכן בלתי ניתן לעיבוד",
    "ERR451GN00": "לא זמין מסיבות משפטיות",
    "ERR500GN00": "שגיאת שרת פנימית",
    "ERR500NT12": "שליחת האימייל לאיפוס הסיסמה נכשלה",
    "ERR501GN00": "לא מיושם",
    "ERR502GN00": "שער רע",
    "ERR503GN00": "שירותים לא זמינים",
    "ERR504GN00": "פסק זמן של שער",
    "event_not_found": "האירוע לא נמצא",
    "expired_session_error": "פג תוקף ההפעלה שלך. \nנא להיכנס שוב.",
    "incomplete_cvc": "קוד האבטחה של הכרטיס שלך אינו שלם!",
    "incomplete_expiry": "תאריך התפוגה של הכרטיס שלך אינו שלם!",
    "incomplete_number": "מספר הכרטיס שלך לא מלא!",
    "invalid_expiry_month_past": "שנת התפוגה של הכרטיס שלך היא בעבר!",
    "invalid_expiry_year": "שנת התפוגה של הכרטיס שלך אינה חוקית!",
    "invalid_expiry_year_past": "שנת התפוגה של הכרטיס שלך היא בעבר!",
    "invalid_number": "מספר הכרטיס שלך לא חוקי!",
    "league_not_found": "הליגה לא נמצאה",
    "live_stream_error_message": "נראה שיש עיכוב קל בשידור החי. אנחנו עובדים במרץ כדי לפתור את הבעיה במהירות האפשרית. תודה על הסבלנות!",
    "login_failed": "ההתחברות נכשלה",
    "page_not_found": "הדף לא נמצא",
    "passwords_dont_match": "הסיסמאות אינן תואמות",
    "popup_closed": "החלון נסגר",
    "team_not_found": "הצוות לא נמצא",
    "vod_corrupted_files": "לא ניתן היה לטעון את הסרטון",
    "vod_files_not_found": "אופס! \nקבצי וידאו לא נמצאו",
    "vod_playback_failed": "אופס! \nההפעלה נכשלה במהלך זרם VOD"
  },
  "labels": {
    "access_code": "הזן קוד גישה",
    "access_time": "תקבל גישה ל",
    "account": "החשבון שלי",
    "active": "פעיל",
    "add_to_selected": "הוסף ל'נבחרים'",
    "all": "הכל",
    "all_results": "כל התוצאות",
    "all_rounds": "כל המחזורים",
    "amount": "כמות",
    "anytime": "בכל זמן",
    "archive": "ארכיון",
    "back_to_site": "חזרה לאתר",
    "bookmark_add": "הוסף לנבחרים",
    "bookmark_remove": "הסר מהנבחרים",
    "category": "קטגוריה",
    "change_product": "שנה מוצר",
    "clip": "קליפ |  קליפים",
    "commerce_category_labels": {
      "free": "חינם",
      "member": "תוכן ברישום",
      "ppv": "תשלום לפי צפייה",
      "premium": "תוכן בתשלום",
      "rental": "השכרה",
      "subscription": "מנויים בלבד"
    },
    "confirm_new_password": "אישור סיסמה חדשה",
    "continue": "המשך",
    "continue_with": "התחבר עם {provider}",
    "country": "מדינה",
    "create_highlight": "יצירת אירוע שיא מהמשחק",
    "dark": "כהה",
    "date": "תאריך",
    "date_added": "תאריך עדכון",
    "days": "ימים",
    "done": "סיים",
    "duration": "משך זמן: בתוקף {duration} {units} לאחר הרכישה | \nמשך: תוקף {duration}",
    "durationRenew": "משך זמן: יחודש {duration} {units} לאחר הרכישה | \nמשך: יחודש ב {duration}",
    "email": "מייל",
    "empty_events_list": "אין עדיין אירועים",
    "enter_new_password": "הגדרת סיסמה חדשה",
    "enter_old_password": "הזן סיסמה ישנה",
    "event_date": "תאריך המשחק",
    "events": "משחקים",
    "follow": "עקוב",
    "following": "מועדפים",
    "footer_links": {
      "about_us": "אודות",
      "custom": "{custom}",
      "faq": "שאלות נפוצות",
      "privacy_policy": "פרטיות",
      "terms_of_service": "תנאים והגבלות"
    },
    "forgot_password": "שכחתי את הסיסמה",
    "full_access": "גישה מלאה",
    "full_name": "שם מלא",
    "fullName": "שם מלא",
    "game_highlights": "רגעי השיא מהמשחק",
    "game_recap": "תקציר משחק",
    "game_videos": "קליפים",
    "gameType_labels": {
      "game": "מִשְׂחָק",
      "other": "אַחֵר",
      "practice": "תרגול",
      "training": "הַדְרָכָה"
    },
    "gender": "מגדר",
    "gender_labels": {
      "female": "נשים",
      "male": "גברים",
      "mixed": "מעורב"
    },
    "get_mobile_app": "הצטרפו לאפליקציית איגוד הכדורסל!",
    "go_to_account": "עבור לחשבון",
    "go_to_event": "עבור לאירוע",
    "go_to_main_page": "עבור לעמוד הראשי",
    "here": "כאן",
    "highlights": "חלק נבחר | קטעים נבחרים",
    "hours": "שעות",
    "inactive": "לֹא פָּעִיל",
    "latest": "משחקים אחרונים",
    "latest_events": "אירועים אחרונים",
    "latest_highlights": "אירועים מרכזיים אחרונים",
    "league": "לִיגָה",
    "less": "פָּחוֹת",
    "light": "בהיר",
    "limited_access": "גישה מוגבלת",
    "live": "שידור חי",
    "load_more": "טען עוד",
    "loading": "טעינה...",
    "lock_event_message": {
      "event_restricted": "אירוע זה מוגבל למיקום שלך",
      "geo_blocking": "אנו מצטערים, אבל הסרטון שאתה מנסה להפעיל מוגבל מהאזור שלך",
      "member": "נא להיכנס כדי לצפות במשחק",
      "premium": "התוכן בתשלום. יש לבחור מבין האפשרויות הבאות -"
    },
    "logout": "התנתק",
    "main": "ראשי",
    "manage_following": "ניהול מועדפים",
    "min_8_characters": "מינימום 8 תווים",
    "minutes": "דקות",
    "modal_labels": {
      "delete_clip": "למחוק את הוידאו?",
      "delete_highlight": "למחוק את הוידאו?",
      "delete_profile": "למחוק את הפרופיל?",
      "delete_tag": "האם אתה בטוח שברצונך להסיר את התגים האלה? |\nהאם אתה בטוח שברצונך להסיר את התג הזה?"
    },
    "months": "חודשים | \nחוֹדֶשׁ | \nחודשים",
    "more": "יותר",
    "my_clips_and_highlights": "קליפים וקטעים נבחרים שלי",
    "my_club": "המועדון שלי",
    "name": "שֵׁם",
    "newest": "החדש ביותר",
    "next": "הבא",
    "no_options_found": "לא נמצאו אפשרויות",
    "oldest": "הישן ביותר",
    "or": "אוֹ",
    "page_not_found": "הדף לא נמצא",
    "panoramic_mode": "אתה במצב פנורמי",
    "password": "סיסמה",
    "password_new": "סיסמה חדשה",
    "password_not_match": "הסיסמאות אינן תואמות",
    "password_old": "סיסמה ישנה",
    "password_repeat": "חזרה על הסיסמה",
    "past_30_days": "30 הימים האחרונים",
    "past_7_days": "7 הימים האחרונים",
    "past_90_days": "90 הימים האחרונים",
    "phone": "טלפון",
    "play_by_play": "כל המהלכים",
    "player_highlights": "רגעי השיא של שחקנים",
    "policy": "מדיניות הפרטיות",
    "postal_code": "מיקוד",
    "powered_by": "מופעל על ידי",
    "ppv_price": "צפה מ-{price}",
    "ppv_tickets": "כרטיסי PPV",
    "purchase": "רכישה",
    "release_date": "תאריך הוצאה",
    "remove_from_selected": "הסר מהנבחרים",
    "reset_password": "אנא הזן את הסיסמה החדשה שלך",
    "rights": "כל הזכויות שמורות",
    "save": "שמור",
    "search": "חיפוש",
    "search_by_sport_type": "חפש לפי סוג ספורט",
    "search_event_league_team": "חפש אירוע, ליגה או קבוצה",
    "search_input_placeholder": "קבוצה, משחק, מועדון וכו'",
    "search_teams": "חפש קבוצות",
    "seconds": "שניות",
    "see_all": "לרשימה המלאה >",
    "select_your_club": "בחר את המועדון שלך",
    "selected_videos": "סרטונים נבחרים",
    "share": "שיתוף",
    "sign_in": "התחבר",
    "sign_up": "הרשמה",
    "skip": "דלג",
    "sport_type": "ענף ספורט",
    "statistics": "סטטיסטיקות",
    "stats": "סטטיסטיקה",
    "submit": "שלח",
    "subscriptions": "מנויים",
    "suggested": "מוּצָע",
    "tag": "תג |  תגים",
    "team": "קְבוּצָה",
    "team_1_logo": "לוגו קבוצה 1",
    "team_2_logo": "לוגו קבוצה 2",
    "today": "היום",
    "total": "סך הכל",
    "type": "סוג",
    "upcoming": "אירועים קרובים",
    "update": "עדכון",
    "update_card": "עדכון כרטיס",
    "videos": "סרטונים",
    "views": "אין צפיות | {count} צפייה | {count} צפיות",
    "watch_full_game": "צפייה במשחק מלא",
    "weeks": "שבועות | \nשָׁבוּעַ | \nשבועות",
    "years": "שנים | \nשָׁנָה | \nשנים",
    "yesterday": "אתמול",
    "your_clips": "הקליפים שלי",
    "your_clips_highlight": "קליפים ורגעי השיא שלך"
  },
  "locales": {
    "bs": "Lokalni",
    "ca": "Catalan",
    "de": "Deutsch",
    "en": "English",
    "es": "Español",
    "fr": "Français",
    "he": "עִברִית",
    "it": "Italiano",
    "ko": "한국인",
    "pl": "Polski",
    "pt": "Português",
    "title": "בחר שפת אתר",
    "uk-UA": "Українська",
    "zh": "中国人"
  },
  "pages": {
    "account_billing": {
      "alert_credit_card_delete_success": "כרטיס החיוב שלך נמחק בהצלחה",
      "alert_credit_card_save_success": "פרטי כרטיס האשראי נשמרו בהצלחה",
      "alert_credit_card_update_success": "פרטי כרטיס האשראי עודכנו בהצלחה",
      "button_back_to_billing_info": "חזרה לפרטי חיוב",
      "card_cvv": "CVC / CVV",
      "card_expiry_date": "תאריך תפוגה",
      "card_holder_name": "שם בעל הכרטיס",
      "card_number": "מספר כרטיס",
      "label_modal_confirm_credit_card_delete": "לאחר שתסיר את כרטיס האשראי שלך, המנוי שלך יבוטל גם כן. \nהתוכן עדיין זמין עבורך עד תאריך הסיום של התוכנית. \nהאם אתה בטוח שברצונך להסיר את כרטיס האשראי?",
      "payment_history_empty_text": "לא נמצאה היסטוריית תשלומים",
      "payment_history_title": "היסטוריית תשלומים",
      "payment_in_progress": "התשלום מתבצע",
      "payment_in_progress_message": "נא לא לסגור דף זה עד שהתשלום שלך יעובד."
    },
    "account_password": {
      "alert_password_update_success": "סיסמתך שונתה בהצלחה"
    },
    "account_subscription": {
      "active_subscription": "מנוי פעיל",
      "alert_access_code_redeem_code_used": "קוד הגישה המבוקש כבר בשימוש",
      "alert_access_code_redeem_not_found": "קוד הגישה המבוקש אינו קיים",
      "alert_access_code_redeemed_success": "קוד הגישה מומש בהצלחה",
      "alert_subscription_cancel_success": "המנוי בוטל בהצלחה",
      "button_back_to_my_subscription": "חזרה למנוי שלי",
      "button_back_to_my_tickets": "בחזרה לכרטיסים שלי",
      "button_subscribe_now": "הירשם עכשיו",
      "button_subscription_cancel": "ביטול רישום",
      "button_subscription_keep": "שמור על מנוי",
      "cancel_subscription_modal_subtitle": "המנוי שלך יבוטל בתום תקופת החיוב שלך בתאריך {date}. \nאתה יכול לשנות את דעתך בכל עת לפני תאריך זה.",
      "cancel_subscription_modal_title": "האם אתה בטוח שברצונך לבטל את המנוי שלך?",
      "checkbox_apply_as_new_credit_card": "שמור את פרטי הכרטיס",
      "label_full_access": "גישה מלאה",
      "label_full_access_description": "גישה מלאה לכל התכנים באתר",
      "label_limited_access": "גישה מוגבלת",
      "label_limited_access_description": "גישה מוגבלת לכל התכנים באתר",
      "label_plan_amount": "סכום התוכנית",
      "label_taxes": "מע\"מ",
      "label_total_billed": "סך החיובים",
      "list_subscriptions_empty": "רשימת המינויים הזמינים ריקה. \nתחזור מאוחר יותר",
      "no_subscriptions_text": "אין מנויים פעילים ברשימה.\n\nתחזור מאוחר יותר",
      "or_select_plan": "או בחר את המסלול שלך",
      "payment_details": "{title}: פרטי תשלום",
      "redeem_access_code_label": "ממש את קוד הגישה שלך כאן",
      "redeem_access_code_title": "מימוש קוד הגישה שלך",
      "renew_subscription_expires": "המנוי חוזר על עצמו. \nתאריך החיוב הבא {date}",
      "subscription_due_date": "תוקף המינוי",
      "subscription_expiration_date": "פג תוקפו על ידי",
      "subscription_expires": "תוקף המנוי יפוג {date}",
      "subscription_last_payment_date": "תאריך תשלום אחרון",
      "subscription_next_charge_date": "תאריך תשלום הבא",
      "tab_all_subscriptions": "כל המנויים",
      "tab_my_subscriptions": "המנויים שלי"
    },
    "account": {
      "account_delete_button": "מחיקת חשבון",
      "account_delete_confirm": "האם את\\ה בטוח\\ה שברצונך למחוק את החשבון שלך?",
      "account_delete_description": "לא ניתן לבטל את הפעולה",
      "account_delete_successfully": "החשבון שלך נמחק בהצלחה!",
      "account_update_successfully": "החשבון שלך עודכן בהצלחה!",
      "tab_billing_title": "פרטי התשלום שלי",
      "tab_devices_title": "המכשירים שלי",
      "tab_general_title": "כללי",
      "tab_password_title": "סיסמה",
      "tab_ppv_access_text": "כרטיס PPV נותן גישה ל",
      "tab_ppv_no_ppv": "אין לך כרטיסי PPV. \nאנא עברו לדף האירוע כדי לקנות כרטיס.",
      "tab_ppv_title": "כרטיסי PPV",
      "tab_subscription_title": "המנויים שלי"
    },
    "auth_login_limit": {
      "current_device": "מכשיר נוכחי",
      "device_limit_reached": "הגעת למגבלת המכשירים",
      "remove_device_to_login": "יש להסיר לפחות מכשיר אחד בכדי להיכנס"
    },
    "auth_login": {
      "device_no_longer_allowed_error": "המכשיר הנוכחי שלך כבר לא נמצא ברשימת המכשירים המותרים.\nאנא התחבר שוב."
    },
    "auth_password": {
      "back_to_sign_in": "חזרה לעמוד כניסה",
      "forgot_password_help_text": "יש לרשום את כתובת המייל לקבלת קישור לחידוש סיסמה",
      "forgot_password_success_text": "דוא\"ל עם הוראות כיצד לאפס את הסיסמה שלך נשלח אל {email}. \nאם לא תקבל את האימייל תוך מספר דקות, לחץ על כפתור שלח מחדש למטה.",
      "resend_instruction": "שלח שוב הוראות",
      "send_reset_link": "שליחת קישור לאיפוס הסיסמה",
      "set_new_password": "הגדרת סיסמה חדשה"
    },
    "auth_sign_in": {
      "auth_terms": "ע”י לחיצה על כפתור המשך הנך מסכים\\מסכימה ל{terms_of_service} ול{privacy_policy} של החברה",
      "new_to": "חדש ל",
      "sign_in_with_provider": "היכנס עם האישורים של {provider} שלך",
      "welcome_message": "ברוכים הבאים"
    },
    "auth_sign_up": {
      "already_have_account": "כבר נרשמת?",
      "back_to_all_categories": "חזרה לכל הקטגוריות",
      "back_to_all_teams": "חזרה לכל הקבוצות",
      "enter_your_details_below": "נא מלא את הפרטים הבאים",
      "follow_category_header": "לבחירתך קבוצות או ליגות מועדפות",
      "follow_teams_header": "עקוב אחר הקבוצות המועדפות עליך",
      "password_updated_successuly_text": "הסיסמה עודכנה בהצלחה"
    },
    "categories": {
      "no_following_category_for_logged_user": "על מנת להתחיל לעקוב אחרי הקבוצות המועדפות עליך, לחץ {here}",
      "no_following_category_for_unlogged_user": "אנא {login} כדי להישאר מעודכן באירועים המועדפים עליך"
    },
    "clips": {
      "title_no_clips": "עדיין אין לך קליפים.\nכנסו לסרטון וצרו את הקליפ הראשון שלכם!",
      "title_no_highlights": "עדין לא יצרת אירועי שיא\nהיכנס.י לוידאו ליצירת אירוע שיא ראשון שלך",
      "title_no_items_with_selected_filter": "לא נמצאו פריטים עם מסנן זה"
    },
    "club": {
      "favorite_club_creating_successfully_text": "המועדון שלך נבחר בהצלחה"
    },
    "clubs": {
      "choose_your_club": "בחר את המועדון שלך",
      "choose_your_club_message": "בחר את המועדון אליו תשויך",
      "manage_following": "ניהול מועדפים"
    },
    "events": {
      "appreciation": "תודה!",
      "event_start_date": "המשחק יתחיל ב {date}",
      "event_will_start_in_a_few_min": "האירוע יתחיל אוטומטית בעוד מספר דקות...",
      "failed_already_used_code": "כבר נעשה שימוש בקוד זה",
      "failed_code_applied_message": "אנא נסה שוב או הזן קוד אחר.",
      "failed_code_applied_title": "קוד לא תקין",
      "failed_purchased_message": "אנא נסה שוב או הזן כרטיס אחר.",
      "failed_statistics": "טעינת הנתונים הסטטיסטיים הקשורים לאירוע זה נכשלה... אנא נסה שוב מאוחר יותר.",
      "game_video_login_message": "אנא היכנס כדי לצפות בסרטוני משחקים",
      "modal_share_title": "שתף את הסרטון",
      "modal_share_with_time": "התחל ב-{time}",
      "purchased_declined": "התשלום נדחה",
      "submit_reedem_code_input_placeholder": "הזן את קוד הגישה שלך כאן",
      "success_code_applied": "הקוד {title} הוחל בהצלחה",
      "success_purchased": "רכשת בהצלחה את {subscription}",
      "success_purchased_secondary": "הרכישה שלך הצליחה",
      "tabs": {
        "event_stats": {
          "empty_stats_data": "הנתונים הסטטיסטיים ריקים",
          "game_board_title": "סטטיסטיקות משחק",
          "score_board_title": "ציון"
        },
        "event_tags": {
          "choose_player_color": "הזן שחקן'",
          "choose_tag": "בחר סוג תג",
          "choose_team": "בחר צוות",
          "create_tag": "התחל לתייג",
          "filters": {
            "by_player_number": "שחקן '",
            "by_team": "לפי צוות",
            "by_type": "לפי סוג",
            "clear_all_btn": "נקה הכל |\nנקה הכל ({count}) |\nנקה הכל ({count})",
            "no_tags": "אין תגים התואמים למסנן שנבחר",
            "popup_title": "לְסַנֵן",
            "search_input_placeholder": "חפש תגיות ספציפיות",
            "select_all": "בחר הכל | \nבחר הכל ({count}) | \nבחר הכל ({count})",
            "show_results_btn": "הראה תוצאות"
          },
          "is_external_content": "זהו תוכן חיצוני, אתה לא יכול ליצור תג",
          "make_tag_global": "הפוך את התג לגלובלי",
          "name_the_tag": "תן שם לתג",
          "pause_all_btn": "השהה הכל",
          "play_all_btn": "שחק הכל",
          "tag_creating_successfully_text": "התג נוצר בהצלחה",
          "tag_deleting_successfully_text": "התג נמחק בהצלחה",
          "tag_updating_successfully_text": "התג עודכן בהצלחה",
          "title_enabled_tagging": "אין תגים ברשימה",
          "title_no_tags": "עדיין לא תוייגו אירועים מעניינים במשחק",
          "title_no_tags_not_logged_in": "אין עדיין תגים ברשימה, אנא היכנס כדי ליצור תגים חדשים",
          "update_tag": "עדכן תג"
        },
        "event_videos": {
          "clip_creating_successfully_text": "הקליפ שלך יהיה מוכן בקרוב",
          "clip_deleted_successfully_text": "הקליפ נמחק בהצלחה",
          "clip_updating_successfully_text": "הקליפ עודכן בהצלחה",
          "create_clip": "חתוך קליפ",
          "name_the_clip": "תן שם לקליפ",
          "rename_clip": "שנה את שם הקליפ",
          "title_enabled_clipping": "אין קליפים ברשימה",
          "title_no_clips": "עדיין לא נחתכו קליפים מהמשחק",
          "title_no_clips_not_logged_in": "אין עדיין קליפים ברשימה, אנא היכנס על מנת ליצור קליפים חדשים"
        }
      },
      "tags_login_message": "אנא היכנס כדי להציג תגים",
      "time_till_kick_off": "זמן עד לפתיחה:",
      "viewing_conditions": "בחר את תנאי הצפייה שלך",
      "watching_event_by_text": "אתה צופה באירוע הזה על ידי"
    },
    "videos": {
      "description_no_items": "זה המקום לסרטונים האהובים עליך.\nשמור, סקור ושתף!",
      "last_viewed": "נצפה לאחרונה",
      "title_no_items": "הוסף כמה סרטונים לנבחרים",
      "user_interesting": "אולי יעניין אותך"
    }
  },
  "sport_types": {
    "americanFootball": "פוטבול",
    "badminton": "כדור נוצה",
    "baseball": "בייסבול",
    "basketball": "כדורסל",
    "beachvolleyball": "כדורעף חופים",
    "bowling": "באולינג",
    "cricket": "קריקט",
    "fieldhockey": "הוקי שדה",
    "flagfootball": "דגל כדורגל",
    "floorball": "פלורבול",
    "football": "כדורגל",
    "futsal": "קטרגל",
    "gymnastics": "התעמלות",
    "handball": "כדוריד",
    "icehockey": "הוקי קרח",
    "lacrosse": "לקרוס",
    "netball": "כדור רשת",
    "other": "אחר",
    "rollerhockey": "הוקי רולר",
    "rugby": "רוגבי",
    "snooker": "סנוקר",
    "soccer": "כדורגל",
    "softball": "סופטבול",
    "swimming": "שחייה",
    "tennis": "טניס",
    "volleyball": "כדורעף",
    "waterpolo": "כדור מים",
    "wrestling": "היאבקות"
  },
  "tags": {
    "baseball_bottom_1st": "1 תחתון",
    "baseball_bottom_2nd": "2 תחתון",
    "baseball_double": "לְהַכפִּיל",
    "baseball_double_play": "משחק כפול",
    "baseball_fly_out": "עוף החוצה",
    "baseball_ground_out": "קרקע החוצה",
    "baseball_hit": "מכה",
    "baseball_home_run": "ריצה הביתה",
    "baseball_popout": "קופץ",
    "baseball_run": "לָרוּץ",
    "baseball_single": "יחיד",
    "baseball_stolen_base": "בסיס גנוב",
    "baseball_strikeout": "פסילה",
    "baseball_substitution": "החלפה",
    "baseball_top_1st": "במקום הראשון",
    "baseball_top_2nd": "העליון 2",
    "baseball_triple_play": "משחק משולש",
    "baseball_tripple": "3 נקודות",
    "baseball_walk": "צעדים",
    "basketball_alley_oop": "אלי-הופ",
    "basketball_assist": "אסיסט",
    "basketball_big_play": "היילייט",
    "basketball_block": "חסימה",
    "basketball_dunk": "הטבעה",
    "basketball_momentym": "תְנוּפָה",
    "basketball_money_time": "מומנטום",
    "basketball_substitution": "חילוף",
    "basketball_three_point": "שלוש נקודות",
    "beach_volleyball_dig": "לַחפּוֹר",
    "beach_volleyball_double": "לְהַכפִּיל",
    "beach_volleyball_free_ball": "כדור חופשי",
    "beach_volleyball_match_point": "נקודת שוויון",
    "beach_volleyball_mishit": "טעות",
    "beach_volleyball_serve": "לְשָׁרֵת",
    "beach_volleyball_set_point": "הגדר נקודה",
    "beach_volleyball_shank": "שוק",
    "beach_volleyball_side_out": "הצד החוצה",
    "beach_volleyball_spike": "דָרְבָּן",
    "beach_volleyball_substitution": "החלפה",
    "field_ball_loss": "איבוד כדור",
    "field_ball_possesion": "החזקת כדור",
    "field_circle_penetration": "חדירת מעגל",
    "field_hockey_4v4": "4v4",
    "field_hockey_big_hit": "להיט גדול",
    "field_hockey_fight": "מַאֲבָק",
    "field_hockey_goal": "מטרה",
    "field_hockey_other": "אַחֵר",
    "field_hockey_power_play": "משחק כוח",
    "field_hockey_save": "להציל",
    "field_hockey_shot": "בְּעִיטָה",
    "field_hockey_substitution": "החלפה",
    "field_interception": "יירוט",
    "field_penalty_corner": "פינת עונשין",
    "field_press_fp_hc": "ללחוץ",
    "field_time_penalty": "עונש זמן",
    "field_turn_over": "לְהִתְהַפֵּך",
    "football_big_catch": "מלכוד גדול",
    "football_big_hit": "להיט גדול",
    "football_big_run": "ריצה גדולה",
    "football_field_goal": "שער שדה",
    "football_kick_return": "בעיטה חזרה",
    "football_kickoff": "לבעוט",
    "football_punt_return": "החזרת נקודות",
    "football_substitution": "החלפה",
    "football_touch_down": "לִנְחוֹת",
    "futsal_corner_kick": "בעיטת קרן",
    "futsal_foul": "עבירה",
    "futsal_free_kick": "בעיטה חופשית",
    "futsal_goal": "שער",
    "futsal_header": "נגיחה",
    "futsal_penalty": "פנדל",
    "futsal_redcard": "כרטיס אדום",
    "futsal_save": "הצלה",
    "futsal_shot": "בעיטה",
    "futsal_shot_on_target": "בעיטה למסגרת",
    "futsal_substitution": "חילוף",
    "futsal_yellowcard": "כרטיס צהוב",
    "general_bad": "רַע",
    "general_drill": "תרגיל",
    "general_good": "טוֹב",
    "gymnastic_wow": "וואו",
    "handball_foul": "עבירה",
    "handball_goal": "שער",
    "handball_penalty_shot": "זריקת עונשין",
    "handball_red_card": "כרטיס אדום",
    "handball_save": "הצלה",
    "handball_shot_on_goal": "זריקה למסגרת",
    "handball_substitution": "חילוף",
    "handball_suspension": "השעיה",
    "handball_yellow_card": "כרטיס צהוב",
    "hockey_4v4": "4v4",
    "hockey_big_hit": "להיט גדול",
    "hockey_fight": "מַאֲבָק",
    "hockey_goal": "מטרה",
    "hockey_power_play": "משחק כוח",
    "hockey_save": "להציל",
    "hockey_shot": "בְּעִיטָה",
    "hockey_substitution": "החלפה",
    "lacrosse_clear": "ברור",
    "lacrosse_face_off": "נאבקת מול",
    "lacrosse_goal": "מטרה",
    "lacrosse_ground_ball": "כדור קרקע",
    "lacrosse_man_up": "תתגבר",
    "lacrosse_penalty": "עוֹנֶשׁ",
    "lacrosse_save": "להציל",
    "lacrosse_shot": "בְּעִיטָה",
    "lacrosse_substitution": "החלפה",
    "other_wow": "אחר וואו",
    "roller_ball_loss": "איבוד כדור",
    "roller_ball_possesion": "החזקת כדור",
    "roller_circle_penetration": "חדירת מעגל",
    "roller_hockey_4v4": "4v4",
    "roller_hockey_big_hit": "להיט גדול",
    "roller_hockey_fight": "מַאֲבָק",
    "roller_hockey_goal": "מטרה",
    "roller_hockey_other": "אַחֵר",
    "roller_hockey_power_play": "משחק כוח",
    "roller_hockey_save": "להציל",
    "roller_hockey_shot": "בְּעִיטָה",
    "roller_hockey_substitution": "החלפה",
    "roller_interception": "יירוט",
    "roller_penalty_corner": "פינה",
    "roller_press_fp_hc": "ללחוץ",
    "roller_time_penalty": "עונש זמן",
    "roller_turn_over": "לְהִתְהַפֵּך",
    "rugby_break_down": "התקלקל",
    "rugby_conversion": "הֲמָרָה",
    "rugby_drop_goal": "ירידה במטרה",
    "rugby_garry_owen": "גארי אוון",
    "rugby_grubber": "גרובר",
    "rugby_knock_on": "לדפוק על",
    "rugby_maul": "מַפֵּץ",
    "rugby_penalty_try": "ניסיון עונשין",
    "rugby_substitution": "החלפה",
    "soccer_corner_kick": "בעיטת קרן",
    "soccer_foul": "עבירה",
    "soccer_free_kick": "בעיטה חופשית",
    "soccer_goal": "שער",
    "soccer_header": "נגיחה",
    "soccer_penalty": "פנדל",
    "soccer_redcard": "כרטיס אדום",
    "soccer_save": "הצלה",
    "soccer_shot": "בעיטה",
    "soccer_shot_on_target": "בעיטה למסגרת",
    "soccer_substitution": "חילוף",
    "soccer_yellowcard": "כרטיס צהוב",
    "volleyball_dig": "לַחפּוֹר",
    "volleyball_double": "לְהַכפִּיל",
    "volleyball_free_ball": "כדור חופשי",
    "volleyball_match_point": "נקודת שוויון",
    "volleyball_mishit": "טעות",
    "volleyball_serve": "לְשָׁרֵת",
    "volleyball_set_point": "הגדר נקודה",
    "volleyball_shank": "שוק",
    "volleyball_side_out": "הצד החוצה",
    "volleyball_spike": "דָרְבָּן",
    "volleyball_substitution": "החלפה",
    "wrestling_wow": "וואו"
  }
}